//get Episode
export const GET_EPISODE = "GET_EPISODE";

//Insert Episode
export const INSERT_EPISODE = "INSERT_EPISODE";

//Update Episode
export const UPDATE_EPISODE = "UPDATE_EPISODE";

//Update Episode Status
export const UPDATE_EPISODE_STATUS = "UPDATE_EPISODE_STATUS";

//Delete Episode
export const DELETE_EPISODE = "DELETE_EPISODE";

//DRM Selection Dialog
export const OPEN_DRM_DIALOG = "OPEN_DRM_DIALOG";
export const CLOSE_DRM_DIALOG = "CLOSE_DRM_DIALOG";

//toast
export const OPEN_EPISODE_TOAST = "OPEN_EPISODE_TOAST";
export const CLOSE_EPISODE_TOAST = "CLOSE_EPISODE_TOAST";

const uploadFileTypes = {
  SET_UPLOAD_FILE: "SET_UPLOAD_FILE",

  SET_UPLOAD_PROGRESS: "SET_UPLOAD_PROGRESS",
  SUCCESS_UPLOAD_FILE: "SUCCESS_UPLOAD_FILE",
  FAILURE_UPLOAD_FILE: "FAILURE_UPLOAD_FILE",
};

export default uploadFileTypes;
